export default __webpack_public_path__ + "static/media/resource-white.82b47b3e.svg";